<template>
	<v-expansion-panels>
		<v-expansion-panel>
			<v-expansion-panel-header>
				<v-row no-gutters>
					<v-col cols="4" class="d-flex align-center">
						<v-badge
							:content="numFiltrosAplicados"
							:value="numFiltrosAplicados > 0"
							color="red"
							overlap
							bordered
							:offset-x="18"
						>
							<v-icon left>mdi-filter</v-icon>
						</v-badge>
						Filtros
					</v-col>
				</v-row>
			</v-expansion-panel-header>
			<v-expansion-panel-content>
				<v-row>
					<v-col :cols="computedColsCard">
						<v-text-field
							v-model="nombreMantenimiento"
							label="Nombre del mantenimiento"
							prepend-inner-icon="mdi-magnify"
							outlined
							clearable
							hide-details
						></v-text-field>
					</v-col>
					<v-col :cols="computedColsCard">
						<v-text-field
							v-model="nombreMaquina"
							label="Nombre de máquina"
							prepend-inner-icon="mdi-magnify"
							outlined
							clearable
							hide-details
						></v-text-field>
					</v-col>
					<v-col :cols="computedColsCard">
						<v-select
							v-model="tipoMantenimiento"
							label="Tipo de mantenimiento"
							:items="tiposMantenimiento"
							outlined
							hide-details
							:append-icon="
								tipoMantenimiento != null
									? 'mdi-close-circle'
									: ''
							"
							@click:append="onClickAppendTipoMant"
						></v-select>
					</v-col>
					<v-col :cols="computedColsCard">
						<MenuDatepicker
							v-model="fecha"
							label="Fecha programada"
							clearable-touch
							outlined
							hide-details
						/>
					</v-col>
				</v-row>
			</v-expansion-panel-content>
		</v-expansion-panel>
	</v-expansion-panels>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import MenuDatepicker from '../shared/MenuDatepicker.vue';
export default {
	components: { MenuDatepicker },
    computed: {
        ...mapState(['filtros','tiposMantenimiento']),
        ...mapGetters(['numFiltrosAplicados']),
		nombreMaquina: {
			get(){
				return this.filtros.nombreMaquina;
			},
			set(newValue){
				this.$store.dispatch('updateFiltros', {
                    ...this.filtros,
                    nombreMaquina: newValue
                });
			}
		},
        nombreMantenimiento: {
            get(){
                return this.filtros.nombreMantenimiento;
            },
            set(newValue){
                this.$store.dispatch('updateFiltros', {
                    ...this.filtros,
                    nombreMantenimiento: newValue
                });
            },
        },
        tipoMantenimiento: {
            get(){
                return this.filtros.tipoMantenimiento;
            },
            set(newValue){
                this.$store.dispatch('updateFiltros', {
                    ...this.filtros,
                    tipoMantenimiento: newValue
                });
            }
        },
		fecha: {
			get(){
				return this.filtros.fecha;
			},
			set(newValue){
				this.$store.dispatch('updateFiltros', {
                    ...this.filtros,
                    fecha: newValue
                });
			}
		},
        isMobile() {
			return this.$vuetify.breakpoint.smAndDown;
		},
		computedColsCard() {
			return this.isMobile ? 12 : 12/this.numFilterCols;
		},
        numFilterCols(){
            return Math.min(Object.keys(this.filtros).length || 1, 3);
        },
    },
    methods: {
        onClickAppendTipoMant(){
			this.tipoMantenimiento = null;
		},
    }
};
</script>